/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

import TableFooter from '../common/TableFooter';
import SimpleTooltip from '../simpleTooltip/SimpleTooltip';

const useStyles = makeStyles((theme) => {
  return {
    thumbnailContainer: {
      backgroundColor: '#172B4D',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      cursor: 'pointer',
      paddingBottom: '80%',
      width: '100%',
    },
    typographyNotAvailable: {
      color: '#999999',
      fontSize: '16px',
      lineHeight: '20px',
      textAlign: 'center',
    },
    typographyVideoSubtitle: {
      color: '#999999',
      cursor: 'pointer',
      fontSize: '14px',
      lineHeight: '16px',
      marginTop: '4px',
      textAlign: 'left',
    },
    typographyVideoTitle: {
      color: '#172B4D',
      cursor: 'pointer',
      fontSize: '18px',
      fontWeight: '600',
      lineHeight: '22px',
      marginTop: '12px',
      textAlign: 'left',
      wordBreak: 'break-word',
      wordWrap: 'break-word',
    },
  };
});

export default ({ videos, total, onOpenViewer, criteria, onPageUpdate }) => {
  const classes = useStyles();
  const handleOpenViewer = (video) => {
    if (onOpenViewer) onOpenViewer(video);
  };

  const handlePageUpdate = (page) => {
    if (onPageUpdate) onPageUpdate(page);
  };

  const renderVideos = () => {
    return videos.map((video) => (
      <Grid key={`${video.id}_${video.resource.id}`} item xs={12} sm={6} md={4} lg={2}>
        <div
          onClick={() => handleOpenViewer(video)}
          className={classes.thumbnailContainer}
          style={{ backgroundImage: `url("${video?.resource?.customThumbnailPath || video.resource?.thumbnailPath}")` }}
        />

        <SimpleTooltip disabled={!video?.description} placement="bottom" title={video?.description || ''}>
          <div onClick={() => handleOpenViewer(video)}>
            <Typography className={classes.typographyVideoTitle}>{video.title}</Typography>
          </div>
        </SimpleTooltip>
      </Grid>
    ));
  };

  if (!videos.length) {
    return <Typography className={classes.typographyNotAvailable}>No results found</Typography>;
  }

  return (
    <div>
      <Grid container spacing={3}>
        {renderVideos()}
      </Grid>
      {!!videos.length && (
        <div>
          <TableFooter count={total} page={criteria.page} rowsPerPage={criteria.limit} changePage={(page) => handlePageUpdate(page)} />
        </div>
      )}
    </div>
  );
};
